import Api from '../../shared/Api';
import { Promise } from 'es6-promise';
import IBrokerTreeNode from './IBrokerTreeNode';
import IBrokerChain from './chain/IBrokerChain';
import { handleError } from '../../shared/ErrorCatching';

class BrokersApi {
    static getBrokerTree(parentNodeId?: number, search?: string, selectedNodeId?: number): any {
        return new Api().get(`/views/brokers/tree`, {
            parentId: parentNodeId,
            search: search,
            nodeId: selectedNodeId
        });
    }

    static addBrokerTreeNode(data: any): any {
        return new Api().post('/views/brokers/tree', data);
    }

    static moveBrokerTreeNode(id: number, data: any): any {
        return new Api().put(`/views/brokers/tree/${id}/move`, data);
    }

    static deleteBrokerTreeNode(id: number): any {
        return new Api().delete(`/views/brokers/tree/${id}`);
    }

    static restoreBrokerTreeNode(id: number): any {
        return new Api().put(`/views/brokers/tree/${id}/restore`);
    }

    // Chain
    static newBrokerChain(): any {
        return new Api().get('/views/brokers/chains/new');
    }

    static createBrokerChain(data: any): any {
        return new Api().post('/views/brokers/chains', data);
    }

    static editBrokerChain(id: number): any {
        return new Promise<any>(
            (resolve: (response: IBrokerChain) => void, reject: (error: any) => void) => {
                new Api()
                    .get(`/views/brokers/chains/${id}/edit`)
                    .then(resolve)
                    .catch((error: any) => {
                        handleError(error, reject);
                    });
            }
        );
    }
    static removeFileChainProfileSettings(id:number): any{
        return new Api().put(`/views/brokers/chains/${id}/removefile`);
    }
    static updateBrokerChain(id: number, data: any): any {
        return new Api().put(`/views/brokers/chains/${id}`, data);
    }
    static uploadBrokerChainFile(id:number,image:any) {
        return new Api().postFiles(`/views/brokers/chains/${id}/upload`, [image]);
    }
    
    // FirmGroup
    static newBrokerFirmGroup(parentId: number): any {
        return new Api().get(`/views/brokers/firmgroups/${parentId}/new`);
    }

    static createBrokerFirmGroup(data: any): any {
        return new Api().post('/views/brokers/firmgroups', data);
    }

    static editBrokerFirmGroup(id: number): any {
        return new Api().get(`/views/brokers/firmgroups/${id}/edit`);
    }

    static updateBrokerFirmGroup(id: number, data: any): any {
        return new Api().put(`/views/brokers/firmgroups/${id}`, data);
    }

    // Firm
    static newBrokerFirm(parentId: number): any {
        return new Api().get(`/views/brokers/firms/${parentId}/new`);
    }
    static removeFileFirmProfileSettings(id:number): any{
        return new Api().put(`/views/brokers/firms/${id}/removefile`);
    }
    static createBrokerFirm(data: any): any {
        return new Api().post('/views/brokers/firms', data);
    }

    static editBrokerFirm(id: number): any {
        return new Api().get(`/views/brokers/firms/${id}/edit`);
    }

    static updateBrokerFirm(id: number, data: any): any {
        return new Api().put(`/views/brokers/firms/${id}`, data);
    }

    // Agent
    static newBrokerAgent(id: number): any {
        return new Api().get(`/views/brokers/agents/${id}/new`);
    }
    static uploadBrokerFirmFile(id:number,image:any) {
        return new Api().postFiles(`/views/brokers/firms/${id}/upload`, [image]);
    }

    static createBrokerAgent(data: any): any {
        return new Api().post('/views/brokers/agents', data);
    }

    static editBrokerAgent(id: number): any {
        return new Api().get(`/views/brokers/agents/${id}/edit`);
    }

    static updateBrokerAgent(id: number, data: any): any {
        return new Api().put(`/views/brokers/agents/${id}`, data);
    }

    // List
    static listBrokerAgent(): any {
        return new Api().get(`/views/brokers/agents`);
    }

    static createListBrokerAgent(data: any): any {
        return new Api().post(`/views/brokers/agents/list`, data);
    }

    static updateListBrokerAgent(id: number, data: any): any {
        return new Api().put(`/views/brokers/agents/list/${id}`, data);
    }

    static deleteListBrokerAgent(id: number): any {
        return new Api().delete(`/views/brokers/agents/${id}/delete`);
    }

    static restoreListBrokerAgent(id: number): any {
        return new Api().put(`/views/brokers/agents/list/${id}/restore`);
    }

    static sendAgentPasswordLink(id: number, sendMail: boolean): any {
        return new Api().post(`/views/brokers/agents/${id}/password-link`, {
            sendMail: sendMail
        });
    }
}

export default BrokersApi;
